// 익명 ID — 브라우저마다 하나. 저장소를 못 쓰면(사생활 모드 등) 이번 세션 동안만 쓰는 값으로 대신한다
const KEY = 'nnt.analytics.anonymousId';

export function loadAnonymousId(newId: () => string): string {
  try {
    const saved = globalThis.localStorage?.getItem(KEY);
    if (saved) return saved;
    const created = newId();
    globalThis.localStorage?.setItem(KEY, created);
    return created;
  } catch {
    return newId();
  }
}
